import React from 'react';

export const ListPlayIcon = (props) => {
  return (
    <svg viewBox='0 0 30 30' fill='currentColor' height='1em' width='1em' {...props}>
      <g id='icon/list/play' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='bi:play-fill' transform='translate(14.000000, 9.500000)'>
          <rect id='ViewBox' x='0' y='0' width='17' height='17'></rect>
          <g
            id='Group'
            transform='translate(4.250000, 3.187500)'
            fill='currentColor'
            fillRule='nonzero'
          >
            <path
              d='M8.07075,6.0530625 L1.3100625,9.9758125 C0.7363125,10.308375 -4.71844785e-16,9.9056875 -4.71844785e-16,9.23525 L-4.71844785e-16,1.38975 C-4.71844785e-16,0.720375 0.73525,0.316625 1.3100625,0.65025 L8.07075,4.573 C8.33642769,4.72466612 8.500417,5.00711093 8.500417,5.31303125 C8.500417,5.61895157 8.33642769,5.90139638 8.07075,6.0530625 Z'
              id='Path'
            ></path>
          </g>
        </g>
        <g
          id='ci:list-plus-copy'
          transform='translate(2.500000, 6.666667)'
          fill='currentColor'
          fillRule='nonzero'
        >
          <path
            d='M12.5,12.7480159 L0.0992063492,12.7480159 L0.0992063492,10.2678571 L12.5,10.2678571 L12.5,12.7480159 Z M14.4321289,7.78769841 L0.0992063492,7.78769841 L0.0992063492,5.30753968 L14.4321289,5.30753968 L14.4321289,7.78769841 Z M16.2202381,2.82738095 L0.0992063492,2.82738095 L0.0992063492,0.347222222 L16.2202381,0.347222222 L16.2202381,2.82738095 Z'
            id='Shape'
          ></path>
        </g>
      </g>
    </svg>
  );
};
